/**
 * @typedef {
 *   PENDENTE_DE_ESCLARECIMENTO |
 *   EM_ANALISE |
 *   ANALISADO
 * } StatusAnalise
 */
const STATUS_ANALISE = {
  PENDENTE_DE_ESCLARECIMENTO: 'PENDENTE_DE_ESCLARECIMENTO',
  EM_ANALISE: 'EM_ANALISE',
  ANALISADO: 'ANALISADO',
};

export default STATUS_ANALISE;
